import React from "react"
import {BenefitHeader} from "@irati-web/benefits/components/benefitHeader"
import {BenefitCardInfo} from "@irati-web/benefits/components/benefitCardInfo"
import {Grid} from "react-bootstrap"
import theme from "@irati/ui/src/global/theme"
import {IconTypes} from "@irati/ui/src/Icon"
import {BenefitSteps} from "@irati-web/benefits/components/benefitSteps"
import {BenefitFAQ} from "@irati-web/benefits/components/benefitFAQ"

export const PayrollGivingLandingScreen = () => {
  return (
    <>
      <Grid>
        <BenefitHeader
          secondCtaUrl="/payroll_giving/landing/"
          secondCtaTitle="payrollGiving.landing.header.rightCta.title"
          title="platform.products.payrollGiving.title"
          subtitle="payrollGiving.landing.section.header.subtitle"
          imageSrc="payrollGiving.landing.section.header.companyLogo"
        />
        <BenefitCardInfo
          title="payrollGiving.landing.sectionOne.title"
          imagePosition="right"
          body="payrollGiving.landing.sectionOne.body"
          imageSrc="payrollGiving.landing.sectionOne.imageRight.src"
          tilesData={tilesData}
        />
      </Grid>
      <BenefitSteps
        title="payrollGiving.landing.steps.start.title"
        firstStepCtaTitle="payrollGiving.landing.steps.ctaOne.title"
        firstStepCtaUrl="/payroll_giving/landing"
        items={steps}
        itemsPerRow={2}
      />
      <Grid>
        <BenefitCardInfo
          title="payrollGiving.landing.sectionTwo.title"
          imagePosition="left"
          ctaText="payrollGiving.landing.header.rightCta.title"
          ctaUrl="/payroll_giving/landing"
          body="payrollGiving.landing.sectionTwo.body"
          imageSrc="payrollGiving.landing.sectionTwo.imageLeft.src"
        />
        <BenefitFAQ
          title="payrollGiving.landing.faq.title"
          faqCtaText="payrollGiving.landing.faq.accessCTA"
          subtitle="payrollGiving.landing.faq.subtitle"
          faqCtaUrl="/payroll_giving/landing"
        />
      </Grid>
    </>
  )
}

const tilesData = [
  {
    description: "payrollGiving.landing.sectionOne.tile.titleOne",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.verified
  },
  {
    description: "payrollGiving.landing.sectionOne.tile.titleTwo",
    iconBgColor: theme.colors.tertiary.s2_400,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.seasonalGift
  },
  {
    description: "payrollGiving.landing.sectionOne.tile.titleThree",
    iconBgColor: theme.colors.primary1_600,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.creditCardHeart
  }
]

const steps = [
  {
    title: "payrollGiving.landing.steps.stepOne.title",
    subTitle: "payrollGiving.landing.steps.stepOne.subtitle",
    image: "payrollGiving.landing.steps.stepOne.image.src"
  },
  {
    title: "payrollGiving.landing.steps.stepTwo.title",
    subTitle: "payrollGiving.landing.steps.stepTwo.subtitle",
    image: "payrollGiving.landing.steps.stepTwo.image.src"
  },
  {
    title: "payrollGiving.landing.steps.stepThree.title",
    subTitle: "payrollGiving.landing.steps.stepThree.subtitle",
    image: "payrollGiving.landing.steps.stepThree.image.src"
  },
  {
    title: "payrollGiving.landing.steps.stepFour.title",
    subTitle: "payrollGiving.landing.steps.stepFour.subtitle",
    image: "payrollGiving.landing.steps.stepFour.image.src"
  }
]
